import { createAsyncThunk } from '@reduxjs/toolkit'
import { MaturityScoring } from '../../types/maturityScoringTypes'
import {
  addMaturityScoringApi,
  deleteMaturityScoringApi,
  getAllMaturityScorings,
  getMaturityScoringBySubDomainIdApi,
  updateMaturityScoring,
} from '../../api/maturityScoringApi'
import { handleError } from '../../utils/errorHandler'

export const getMaturityScorings = createAsyncThunk<
  { maturityScorings: MaturityScoring[]; total: number; totalPages: number },
  { search?: string; page?: number; pageSize?: number },
  { rejectValue: string }
>(
  'maturityScoring/getAllMaturityScorings',
  async ({ search, page, pageSize }, thunkAPI) => {
    try {
      const response = await getAllMaturityScorings({ search, page, pageSize })
      return {
        maturityScorings: response.maturityScoring,
        total: response.total,
        totalPages: response.totalPages,
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(await handleError(error))
    }
  }
)

export const deleteMaturityScoring = createAsyncThunk<
  void,
  string,
  { rejectValue: string }
>(
  'maturityScoring/deleteMaturityScoring',
  async (MaturityScoringId, thunkAPI) => {
    try {
      await deleteMaturityScoringApi(MaturityScoringId)
    } catch (error) {
      return thunkAPI.rejectWithValue(await handleError(error))
    }
  }
)

// Update the createAsyncThunk action
export const addMaturityScoring = createAsyncThunk<
  MaturityScoring,
  FormData,
  { rejectValue: string }
>('maturityScoring/addMaturityScoring', async (formData, thunkAPI) => {
  try {
    const response = await addMaturityScoringApi(formData)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const updateMaturityScoringAction = createAsyncThunk<
  MaturityScoring,
  { id: string; formData: FormData },
  { rejectValue: string }
>('maturityScoring/update', async ({ id, formData }, thunkAPI) => {
  try {
    const response = await updateMaturityScoring(id, formData)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const getMaturityScoringBySubDomainId = createAsyncThunk<
  MaturityScoring,
  string,
  { rejectValue: string }
>(
  'maturityScoring/getMaturityScoringBySubDomainId',
  async (SubDomainId, thunkAPI) => {
    try {
      const response = await getMaturityScoringBySubDomainIdApi(SubDomainId)
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue(await handleError(error))
    }
  }
)
